import classNames from "classnames";
import FileButton from "components/FileButton";
import { TYPE_BATTLE, TYPE_BATTLE_DRAW } from "constant/config";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ItemInterface, ReactSortable } from "react-sortablejs";

interface Props {
	answerIds: number[];
	isEditMode: boolean;
	type: string;
	//register: ReturnType<typeof useForm>["register"];
	//control: ReturnType<typeof useForm>["control"];
}

export default function Answers({ answerIds, isEditMode, type }: Props) {
	const { register } = useFormContext();
	const { t } = useTranslation();
	const [items, setItems] = useState<ItemInterface[]>([]);
	const [drag, setDrag] = useState<boolean>(false);
	const [dragId, setDragId] = useState<number>(0);

	useEffect(() => {
		setItems(
			answerIds.map((id) => {
				return {
					id,
				};
			}),
		);
	}, [answerIds]);
	/**
	 * 항목 추가
	 */
	const handleAnswerAdd = useCallback(() => {
		if (items.length === 10) {
			alert(t("투표 항목은 최대 10개까지 만들 수 있습니다."));
			return;
		}
		setItems([...items, { id: Math.random() }]);
	}, [items, t]);

	/**
	 * 항목 삭제
	 */
	const handleAnswerDelete = useCallback(
		(id) => () => {
			if (items.length <= 2) {
				alert(t("투표 항목은 최소 2개 이상 등록해야 합니다."));
				return;
			}
			if (window.confirm(t("해당 투표 항목을 삭제하시겠습니까?"))) {
				const index = items.findIndex((item) => {
					return item.id === id;
				});
				if (index > -1) {
					items.splice(index, 1);
					setItems([...items]);
				}
			}
		},
		[items, t],
	);

	const handleMouseOver = useCallback(
		(e) => {
			//console.log(e.currentTarget.dataset.id, typeof e.currentTarget.dataset.id);
			if (!drag) {
				setDragId(parseFloat(e.currentTarget.dataset.id));
			}
		},
		[drag],
	);

	const handleMouseLeave = useCallback((e) => {
		setDragId(0);
	}, []);
	//className="scrollarea area"

	const isBattleMode = useMemo(() => type === TYPE_BATTLE || type === TYPE_BATTLE_DRAW, [type]);
	return (
		<>
			<ReactSortable
				tag="ul"
				className="item_wrap"
				handle=".btn_handle"
				list={items}
				setList={setItems}
				ghostClass="move"
				animation={150}
				disabled={isEditMode}
				onStart={() => {
					setDrag(true);
					setDragId(0);
				}}
				onEnd={() => setDrag(false)}
			>
				{items.map((item: ItemInterface, index: number) => (
					<li
						key={item.id}
						className={classNames({ hv: dragId === item.id, hide: isBattleMode && index > (type === TYPE_BATTLE_DRAW?2:1) })}
						onMouseOver={handleMouseOver}
						onMouseLeave={handleMouseLeave}
					>
						<input type="hidden" name={`index[${item.id}]`} value={index} ref={register} />
						<input type="hidden" name={`answerId[${item.id}]`} value={item.id} ref={register} />
						{!isBattleMode && (
							<button type="button" className="btn_del" onClick={handleAnswerDelete(item.id)}>
								<span>삭제</span>
							</button>
						)}
						<div className="list-title">
							<input
								type="text"
								name={`answer[${item.id}]`}
								placeholder={t("항목을 입력해주세요.")}
								ref={register}
								size={30}
								maxLength={30}
								readOnly={isEditMode}
							/>
						</div>
						<div className="vote-img">
							{/*<Controller as={FileButton} name={`image[${item.id}]`} control={control} />*/}
							<FileButton id={item.id} />
						</div>
						<div className="btn_handle">
							<span>항목이동</span>
						</div>
					</li>
				))}
			</ReactSortable>
			{!isEditMode && !isBattleMode && (
				<button type="button" className="btn_addList" onClick={handleAnswerAdd}>
					<span>{t("항목 추가")}</span>
				</button>
			)}
		</>
	);
}
